import BaseController from "./base_controller"
import html2canvas from "html2canvas"

export default class extends BaseController {
  static targets = ['exportable']

  copy(event) {
    if (event) event.preventDefault()

    // 1. Show loader
    this.showLoading()

    try {
      // 2. THE FIX: Declare the clipboard write IMMEDIATELY.
      // We pass a Promise (this.generateBlob) to the ClipboardItem constructor.
      // This tells the browser: "I am writing to the clipboard right now (valid user action),
      // but the data will arrive in a few seconds."
      const item = new ClipboardItem({
        "image/png": this.generateBlob()
      });

      // 3. Initiate the write. The browser will wait for the promise to resolve.
      navigator.clipboard.write([item])
        .then(() => {
          window.dispatchEvent(new CustomEvent("role-permissions:notify", {
            detail: { message: "Copied results to the clipboard!" },
            bubbles: true
          }));
        })
        .catch((error) => {
          console.error("Clipboard write failed:", error)
          alert("Failed to copy image. Your browser might block long-running clipboard tasks.")
        })
        .finally(() => {
          this.hideLoading()
        });

    } catch (error) {
      console.error("Setup failed:", error)
      this.hideLoading()
      alert("Clipboard API not supported or blocked.")
    }
  }

  // This function now returns a Promise<Blob> and handles the heavy lifting
  async generateBlob() {
    let clone = null;

    // Optional: Small delay inside the worker to ensure the UI has time to
    // actually render the "Loading" spinner before the CPU freezes for html2canvas.
    await new Promise(r => setTimeout(r, 50));

    try {
      const original = this.exportableTarget
      clone = original.cloneNode(true)

      // Apply styles to the clone
      Object.assign(clone.style, {
        display: "block",
        position: "fixed",
        top: "0",
        left: "0",
        zIndex: "-9999",
        opacity: "1",
        backgroundColor: "#ffffff",
        width: "900px",
        height: "auto",
        margin: "0",
        padding: "20px"
      })

      document.body.appendChild(clone)

      // Generate Canvas
      const canvas = await html2canvas(clone, {
        scale: 2,
        useCORS: true,
        logging: false,
        backgroundColor: "#ffffff",
        width: 900,
        windowWidth: 1200,
        onclone: () => Promise.resolve()
      })

      // Convert to Blob
      const blob = await new Promise((resolve, reject) => {
        canvas.toBlob((b) => {
          b ? resolve(b) : reject(new Error("Canvas to Blob failed"))
        }, 'image/png')
      });

      return blob;

    } catch (error) {
      console.error("Image generation failed:", error);
      throw error; // This causes the ClipboardItem promise to reject
    } finally {
      if (clone) clone.remove();
      // Note: We do NOT call hideLoading() here, strictly in the copy() .finally block
    }
  }
}